<template>
<!--    <v-snackbar class="mt-5" v-model="snackbar" color="black" :timeout="0" vertical top style="width: 100vw;">-->
  <v-dialog v-model="snackbar" full-width persistent>
      <v-card>
        <v-card-title class="grey darken-3 white--text"> Info thanks to DSGVO 💡🙈🙊 </v-card-title>
        <v-card-text style="text-align:justify">
          Damit du dich möglichst wohl auf unserer Seite fühlst 😄😊💖 ,
          benutzen wir Google Analytics 🔮🔮🔮 und Cookies 🍪🍪🍪. <br>
          <v-btn @click="$emit('showDsgvo')" flat color="primary" class="ml-0 pl-0">↪️ Mehr Erfahren</v-btn><br>
          <br>
          Beim klicken auf <span class="green--text">Accept ✔</span> akzeptierst du die Verwendung der genannten Tools.<br><br>
          <v-btn class="pl-0 ml-0" flat tiny color="primary"
                 href="https://cookies.insites.com/about-cookies/"
                 target="_blank"
                 style="font-size:12px; max-width:100%; overflow:auto;"> Oder guck dir hier ein lustiges Video 🍿🎥 zu 🍪 an.</v-btn>

          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="green" flat @click="disableDialog()"> Accept ✔️</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
 <!--   </v-snackbar>-->
</template>

<script>
  export default {
    name: "Analytics",
    data() {
      return {
        snackbar: false
      }
    },
    methods: {
      addAnalytics() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
          (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
          'gtm.start':
          new Date().getTime(), event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&ampl=' + l : '';
          j.async = true;
          j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', 'GTM-M2LB8HX');`;

        document.getElementsByTagName('head')[0].appendChild(script);

        const script2 = document.createElement('script');
        script2.setAttribute('async', 'true');
        script2.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-129576784-1');

        document.getElementsByTagName('head')[0].appendChild(script2);

        const script3 = document.createElement('script');
        script3.type = 'text/javascript';
        script3.innerHTML = `
         window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
         }
         gtag('js', new Date());
        gtag('config', 'UA-129576784-1');
        if(ga) ga('set', 'anonymizeIp', true);`;

   //     document.getElementsByTagName('head')[0].appendChild(script3);
        this.$ga.setToken(true, Date.now() + 999999 * 99999)
      },
      disableDialog(){
        this.snackbar = false
        this.$emit('showNotifications')
      }
    },
    created() {
      if (!this.$ga.hasAnalytics()) {
        this.snackbar = true
        this.$ga.setToken(true, Date.now() + 999999 * 999999)
    //    this.addAnalytics()
      } else {
    //    this.addAnalytics()
        this.$ga.setToken(true, Date.now() + 999999 * 999999)
      }

    }
  }
</script>

<style>
  #app > div.application--wrap > main > div > div.v-card.theme--light > div > div > div {
    width: 100vw;
  }
</style>
